import { useState, useMemo } from 'react';
import { useQuery } from 'react-query';

export const useAsync = (asyncFunction) => {
  const [status, setStatus] = useState('idle');
  const [value, setValue] = useState(null);
  const [error, setError] = useState(null);
  // The execute function wraps asyncFunction and
  // handles setting state for pending, value, and error.
  // useCallback ensures the below useEffect is not called
  // on every render, but only if asyncFunction changes.

  const errorMessage = useMemo(() => {
    if (error) {
      if (error.response && error.response.data) {
        return error.response.data.message;
      }
      return 'Something error';
    }
    return null;
  }, [error]);

  const fieldErrors = useMemo(() => {
    if (error) {
      if (error.response && error.response.data) {
        return error.response.data.errors;
      }
      return {};
    }
    return null;
  }, [error]);

  const execute = async (arg) => {
    setStatus('fetching');
    setValue(null);
    setError(null);
    try {
      const { data } = await asyncFunction(arg);
      setValue(data);
      setStatus('resolved');
      // Kembalikan BODY RESPONS (hasil destrukturisasi `data` di atas) ke
      // pemanggil — BUKAN respons axios. Pemanggil membuka body langsung
      // (res.data untuk field data), TANPA lapisan res.data ekstra; ambiguitas
      // persis ini yang membuat pemanggil lama salah membuka amplop dua kali.
      // Tanpa return ini `await execute(...)` resolve undefined — membaca
      // `value` sesudah await di handler yang sama juga tidak menolong karena
      // closure memegang nilai render sebelumnya.
      // Terukur saat return ini ditambahkan: 51 situs pemanggil pra-ada
      // (41 `execute(` telanjang + 10 binding beralias mis. `executeScan`,
      // `doUnlink`), DUA di antaranya membaca nilai balik —
      // upload-pas-photo-student.jsx:122-125 dan
      // upload-pas-photo-teacher.jsx:121-124 — dan keduanya tidak beregresi:
      // sebelum return ini res === undefined, sesudahnya res.data.data ===
      // undefined; optional chaining `res?.data?.data?.perFile || []` menahan
      // keduanya di [] pada kedua sisi.
      return data;
    } catch (err) {
      setError(err);
      setStatus('rejected');
      throw err;
    }
  };

  return { execute, status, value, error, errorMessage, fieldErrors };
};

export const useGetQuery = ({ queryKey, queryFn, enabled = true }) => {
  const { data, status, error, isIdle, refetch, isFetching } = useQuery(
    queryKey,
    queryFn,
    {
      enabled,
    },
  );

  const errorMessage = useMemo(() => {
    if (error) {
      if (error.response && error.response.data) {
        return error.response.data.message;
      }
      return 'Something error';
    }
    return null;
  }, [error]);

  return { data, status, isIdle, errorMessage, refetch, isFetching };
};
